import { format } from "date-fns";

export const sampleAttendanceData = [
  [
    "EmployeeCode",
    "AttendanceYear",
    "AttendanceMonth",
    "AttendanceValue_1",
    "InTime_1",
    "OutTime_1",
    "AttendanceValue_2",
    "InTime_2",
    "OutTime_2",
    "AttendanceValue_3",
    "InTime_3",
    "OutTime_3",
    "AttendanceValue_4",
    "InTime_4",
    "OutTime_4",
    "AttendanceValue_5",
    "InTime_5",
    "OutTime_5",
    "AttendanceValue_6",
    "InTime_6",
    "OutTime_6",
    "AttendanceValue_7",
    "InTime_7",
    "OutTime_7",
    "AttendanceValue_8",
    "InTime_8",
    "OutTime_8",
    "AttendanceValue_9",
    "InTime_9",
    "OutTime_9",
    "AttendanceValue_10",
    "InTime_10",
    "OutTime_10",
    "AttendanceValue_11",
    "InTime_11",
    "OutTime_11",
    "AttendanceValue_12",
    "InTime_12",
    "OutTime_12",
    "AttendanceValue_13",
    "InTime_13",
    "OutTime_13",
    "AttendanceValue_14",
    "InTime_14",
    "OutTime_14",
    "AttendanceValue_15",
    "InTime_15",
    "OutTime_15",
    "AttendanceValue_16",
    "InTime_16",
    "OutTime_16",
    "AttendanceValue_17",
    "InTime_17",
    "OutTime_17",
    "AttendanceValue_18",
    "InTime_18",
    "OutTime_18",
    "AttendanceValue_19",
    "InTime_19",
    "OutTime_19",
    "AttendanceValue_20",
    "InTime_20",
    "OutTime_20",
    "AttendanceValue_21",
    "InTime_21",
    "OutTime_21",
    "AttendanceValue_22",
    "InTime_22",
    "OutTime_22",
    "AttendanceValue_23",
    "InTime_23",
    "OutTime_23",
    "AttendanceValue_24",
    "InTime_24",
    "OutTime_24",
    "AttendanceValue_25",
    "InTime_25",
    "OutTime_25",
    "AttendanceValue_26",
    "InTime_26",
    "OutTime_26",
    "AttendanceValue_27",
    "InTime_27",
    "OutTime_27",
    "AttendanceValue_28",
    "InTime_28",
    "OutTime_28",
    "AttendanceValue_29",
    "InTime_29",
    "OutTime_29",
    "AttendanceValue_30",
    "InTime_30",
    "OutTime_30",
    "AttendanceValue_31",
    "InTime_31",
    "OutTime_31",
  ],
  [
    10,
    "2024",
    "01",
    1,
    "09:00",
    "18:00",
    1,
    "09:00",
    "18:00",
    1,
    "09:00",
    "18:00",
    1,
    "09:00",
    "18:00",
    1,
    "09:00",
    "18:00",
    1,
    "09:00",
    "18:00",
    1,
    "09:00",
    "18:00",
    1,
    "09:00",
    "18:00",
    1,
    "09:00",
    "18:00",
    1,
    "09:00",
    "18:00",
    1,
    "09:00",
    "18:00",
    1,
    "09:00",
    "18:00",
    1,
    "09:00",
    "18:00",
    1,
    "09:00",
    "18:00",
    1,
    "09:00",
    "18:00",
  ],
];

export const sampleEmployeeData = {
  uniqueId: "7070",
  fullName: "Above 70",
  employeeType: "Singaporean",
  icno: "7070",
  gender: "Male",
  email: "test@gmail.com",
  dob: "02/03/1953",
  nationality: "",
  race: "Malay",
  religion: "Christian",
  maritalStatus: "Married",
  hpno: "8888888",
  officeNo: "",
  address1: "7070",
  address2: "",
  address3: "",
  country: "Singapore",
  postalCode: "707070",
  isActive: true,
  // createUser: "winapp",
  // createDate: "2024-11-13T16:50:00",
  // modifyUser: "winapp",
  // modifyDate: "2024-11-15T14:07:40.839Z",
  residentialType: "S",
  prDate: "",
  passCode: 0,
  skilledOrUnSkilled: "S",
  passIssueDate: "",
  passExpiryDate: "",
  contributionCode: 0,
  employmentStatus: 0,
  joinDate: "",
  confirmationDate: "",
  resignedDate: "",
  jobTitle: "",
  designationCode: 2,
  departmentCode: 2,
  workDayPerWeek: 0,
  paymentMode: 3,
  reportTo: "",
  basicSalary: 6900,
  haveOverTimePay: false,
  haveLoginPermission: true,
  prcpfType: "F",
  hourlySalary: 0,
  daySalary: 0,
  otDaySalary: 0,
  otPaidInDays: 0,
  otHourlySalary: 0,
  dailyAllowance: 0,
  haveOverTimePayForExtraHours: true,
  haveNeedAttendance: true,
  restDay: "",
  loginUserName: "",
  employeePhotoStr: "",
  aliasName: "",
  preferedName: "",
  groups: "",
  probationPeriodStart: "",
  probationPeriodEnd: "",
  surpervisorName: "",
  academicQualification: "Masters",
  bloodGroup: "O+",
  placeOfBirth: "",
  identification: "Driving License",
  emergencyContactPerson: "8888888",
  relationship: "1",
  payrollFrequency: "",
  salaryType: "Hourly",
  bankName: "DBS",
  accountNo: "1234567897070",
  personalEmail: "",
  skillSet: "",
  workingHoursPerDay: 8,
  noofworkingDaysPerWeek: "5.5",
  basicPayAmountType: "SGD",
  superAdmin: false,
  workingTimingPerDay: "8",
  userSecurity: "",
  claimsTypes: "0",
  lengthofNoticePeriod: "60",
  cpfEntitled: "",
  contributesSDL: "0",
  sdlBreakdown: "",
  fundDonation: "",
  clockInAndOutOnMobile: "True",
  remarks: "",
  jobGrade: "",
  oT1PayRate: 1,
  oT2PayRate: 2,
  oT3PayRate: 3,
  nsEligible: true,
  monday: 8.25,
  tuesday: 8.25,
  wednesday: 8.25,
  thursday: 8.25,
  friday: 8.25,
  saturday: 3.5,
  sunday: 0,
  finNumber: "F8849034S",
  mondayWorkingMode: "1",
  tuesdayWorkingMode: "1",
  wednesdayWorkingMode: "1",
  thursdayWorkingMode: "1",
  fridayWorkingMode: "1",
  saturdayWorkingMode: "0.5",
  sundayWorkingMode: "0",
  eatingHabit: "Veg / Non Veg",
  havingKids: true,
  havingDependants: true,
  accommodationByCompany: true,
  localContactNumber: 85967413,
  overseasContactNumber: 74125896,
  ppeSize: "",
  shoeSize: "",
  ppeRemarks: "",
  extraHoursRate: "",
};

export const sampleTimelogData = {
  // employeeCode: "10",
  Date: format(new Date(), "yyyy-MM-dd"),
  // attendanceValue: 1,
  In: "09:00",
  Out: "18:00",
  Remarks: "Sample remarks",
};

export const sampleAllowanceAndDeductionData = {
  "Employee No": "EMP0001",
  Employee: "John Doe",
  Type: "Addition / Deduction",
  "Addition/Deduction Type": "Sample Allowance",
  Department: "OPERATION",
  Amount: 1000,
  "Addition/Deduction Date": format(new Date(), "yyyy-MM-dd"),
};
// export const sampleAttendanceData = [
//   [
//     "EmployeeCode",
//     "AttendanceDate_1",
//     "AttendanceValue_1",
//     "InTime_1",
//     "OutTime_1",
//     "AttendanceDate_2",
//     "AttendanceValue_2",
//     "InTime_2",
//     "OutTime_2",
//     "AttendanceDate_3",
//     "AttendanceValue_3",
//     "InTime_3",
//     "OutTime_3",
//     "AttendanceDate_4",
//     "AttendanceValue_4",
//     "InTime_4",
//     "OutTime_4",
//     "AttendanceDate_5",
//     "AttendanceValue_5",
//     "InTime_5",
//     "OutTime_5",
//     "AttendanceDate_6",
//     "AttendanceValue_6",
//     "InTime_6",
//     "OutTime_6",
//     "AttendanceDate_7",
//     "AttendanceValue_7",
//     "InTime_7",
//     "OutTime_7",
//     "AttendanceDate_8",
//     "AttendanceValue_8",
//     "InTime_8",
//     "OutTime_8",
//     "AttendanceDate_9",
//     "AttendanceValue_9",
//     "InTime_9",
//     "OutTime_9",
//     "AttendanceDate_10",
//     "AttendanceValue_10",
//     "InTime_10",
//     "OutTime_10",
//     "AttendanceDate_11",
//     "AttendanceValue_11",
//     "InTime_11",
//     "OutTime_11",
//     "AttendanceDate_12",
//     "AttendanceValue_12",
//     "InTime_12",
//     "OutTime_12",
//     "AttendanceDate_13",
//     "AttendanceValue_13",
//     "InTime_13",
//     "OutTime_13",
//     "AttendanceDate_14",
//     "AttendanceValue_14",
//     "InTime_14",
//     "OutTime_14",
//     "AttendanceDate_15",
//     "AttendanceValue_15",
//     "InTime_15",
//     "OutTime_15",
//   ],
//   [
//     10,
//     "2024-11-01",
//     1,
//     "09:00",
//     "18:00",
//     "2024-11-02",
//     1,
//     "09:00",
//     "18:00",
//     "2024-11-03",
//     1,
//     "09:00",
//     "18:00",
//     "2024-11-04",
//     1,
//     "09:00",
//     "18:00",
//     "2024-11-05",
//     1,
//     "09:00",
//     "18:00",
//     "2024-11-06",
//     1,
//     "09:00",
//     "18:00",
//     "2024-11-07",
//     1,
//     "09:00",
//     "18:00",
//     "2024-11-08",
//     1,
//     "09:00",
//     "18:00",
//     "2024-11-09",
//     1,
//     "09:00",
//     "18:00",
//     "2024-11-10",
//     1,
//     "09:00",
//     "18:00",
//     "2024-11-11",
//     1,
//     "09:00",
//     "18:00",
//     "2024-11-12",
//     1,
//     "09:00",
//     "18:00",
//     "2024-11-13",
//     1,
//     "09:00",
//     "18:00",
//     "2024-11-14",
//     1,
//     "09:00",
//     "18:00",
//     "2024-11-15",
//     1,
//     "09:00",
//     "18:00",
//   ],
// ];
